import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

type Pillar = Readonly<{ id: string; title: TranslationKey; description: TranslationKey }>;

export const PILLARS: readonly Pillar[] = [
	{
		id: 'independent',
		title: translationKey('corgi.impact_page.powered_by_people.pillars.independent.title'),
		description: translationKey('corgi.impact_page.powered_by_people.pillars.independent.description'),
	},
	{
		id: 'countries',
		title: translationKey('corgi.impact_page.powered_by_people.pillars.countries.title'),
		description: translationKey('corgi.impact_page.powered_by_people.pillars.countries.description'),
	},
	{
		id: 'no_ads',
		title: translationKey('corgi.impact_page.powered_by_people.pillars.no_ads.title'),
		description: translationKey('corgi.impact_page.powered_by_people.pillars.no_ads.description'),
	},
];
